import { useEffect, useState } from "react";
import { collection, onSnapshot, doc, getDoc } from "firebase/firestore";  // 👈 agrega doc, getDoc
import { db } from "../../../../firebase/firebase";
import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../../Modulo_Responsive/Hooks/useResponsive";

const Pista_Cono = () => {
    const { sCell } = useResponsive();
    const [media, setMedia] = useState(null);
    const [titulo, setTitulo] = useState("Mira esta pista"); // fallback

    // Carga el título editable
    useEffect(() => {
        const cargarTitulo = async () => {
            try {
                const snap = await getDoc(doc(db, "configuracion", "textos"));
                if (snap.exists() && snap.data().pista_cono_titulo) {
                    setTitulo(snap.data().pista_cono_titulo);
                }
            } catch (e) {
                console.error("Error cargando título pista:", e);
            }
        };
        cargarTitulo();
    }, []);

    useEffect(() => {
        const unsub = onSnapshot(collection(db, "cono-pista"), (snap) => {
            const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            if (docs.length > 0) {
                docs.sort((a, b) => (a.orden ?? 0) - (b.orden ?? 0));
                setMedia(docs[0]);
            } else {
                setMedia(null);
            }
        });
        return () => unsub();
    }, []);

    if (!media?.url) return null;

    const esVideo = media.tipo === "video" || /\.(mp4|webm|mov|ogg)(\?|$)/i.test(media.url);

    return (
        <Grid container justifyContent="center" alignItems="center" size={{ xs: 12 }} sx={{ pt: 6, pb: 4 }}>

            <Grid container justifyContent="center" size={{ xs: 12 }} sx={{ pb: 3 }}>
                <Typography
                    component="h2"
                    sx={{
                        fontFamily: 'Abril Fatface',
                        fontSize: sCell ? 28 : 42,
                        fontWeight: 600,
                        textAlign: "center",
                        color: "black",
                    }}
                >
                    {titulo}  {/* 👈 */}
                </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 8, md: 5 }}>
                {esVideo ? (
                    <video
                        src={media.url}
                        autoPlay
                        loop
                        controls
                        playsInline
                        style={{ width: "100%", borderRadius: 12, display: "block" }}
                    />
                ) : (
                    <img
                        src={media.url}
                        alt="Pista"
                        style={{ width: "100%", borderRadius: 12, display: "block" }}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default Pista_Cono;